import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { useCallback, useEffect, useState } from "react";
import { getMenus } from "@/services/menu";
import { PRIVATE_PATHS } from "@/routes/privateRoutes";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";

export const MainNavigation = () => {
  const [menus, setMenus] = useState([]);
  const { isMaster, canView } = usePermissions();

  const handleMenus = useCallback(async () => {
      const response: any = await getMenus();
      setMenus(response.data || []);
  }, []);

  useEffect(() => {
    handleMenus();
  }, []);

  const navigate = useNavigate();

  const handleRouteNavigation = useCallback(
    (value: any) => {
      return navigate(value);
    },
    [navigate]
  );

  const getPath = (id: number): string => {
    let item = PRIVATE_PATHS?.filter((icon) => {
      return icon?.key === id;
    });
    if (item.length > 0) {
      return item[0].path || "";
    } else {
      return "";
    }
  };

  // Função para filtrar menus baseado nas permissões
  const filterMenusByPermissions = (menuList: any[]): any[] => {
    if (isMaster) return menuList;

    return menuList.filter((item: any) => {
      // Se tem submenus, verifica se pelo menos um submenu tem permissão
      if (item?.subMenus && item?.subMenus.length > 0) {
        const filteredSubMenus = item.subMenus.filter((subMenu: any) => {
          if (subMenu?.subMenus && subMenu?.subMenus.length > 0) {
            return subMenu.subMenus.some((subSubMenu: any) => canView(subSubMenu.id));
          }
          return canView(subMenu.id);
        });
        
        // Retorna o menu se pelo menos um submenu tem permissão
        return filteredSubMenus.length > 0;
      }
      
      // Se não tem submenus, verifica se tem permissão direta
      return canView(item.id);
    });
  };

  // Função para filtrar submenus baseado nas permissões
  const filterSubMenusByPermissions = (subMenus: any[]): any[] => {
    if (isMaster) return subMenus;

    return subMenus.filter((subMenu: any) => {
      if (subMenu?.subMenus && subMenu?.subMenus.length > 0) {
        const filteredSubSubMenus = subMenu.subMenus.filter((subSubMenu: any) => 
          canView(subSubMenu.id)
        );
        return filteredSubSubMenus.length > 0;
      }
      return canView(subMenu.id);
    });
  };

  // Função recursiva para renderizar menus e submenus de qualquer nível
  const renderMenuItems = (menuList: any[]) => {
    return menuList.map((item: any) => {
      if (item?.subMenus && item?.subMenus.length > 0) {
        // Se houver submenus, renderiza um SubMenu e chama recursivamente
        return (
          <SubMenu key={item.id} label={item?.nome}>
            {renderMenuItems(filterSubMenusByPermissions(item.subMenus))}
          </SubMenu>
        );
      } else if (item?.nome) {
        // Se não houver submenus, renderiza um MenuItem
        return (
          <MenuItem
            key={item.id}
            rootStyles={{ backgroundColor: "#111827" }}
            onClick={() => handleRouteNavigation(getPath(item.id))}
          >
            {item?.nome || ""}
          </MenuItem>
        );
      }
      return null;
    });
  };

  const filteredMenus = filterMenusByPermissions(menus);

  return (
    <Sidebar
      backgroundColor="#111827"
      breakPoint="md"
      width="300px"
      rootStyles={{
        overflowX: "hidden",
        height: "450px",
        borderRightWidth: 0,
      }}
    >
      <Menu
        closeOnClick
        menuItemStyles={{
          button: {
            "&:hover": {
              backgroundColor: "#111827",
              borderRadius: 7,
            },
            backgroundColor: "#111827",
            color: "#FFF",
          },
          subMenuContent: {
            backgroundColor: "#111827",
          },
          root: {
            backgroundColor: "#111827",
            color: "#FFF",
          },
        }}
        rootStyles={{
          fontSize: 14,
          fontWeight: 400,
          marginTop: "1rem",
          backgroundColor: "#111827",
          overflow: "hidden",
        }}
      >
        {renderMenuItems(filteredMenus)}
      </Menu>
    </Sidebar>
  );
};
